export const excludedFields = [
  "plan_recovery_progress",
  "strengths_interests",
  "hope_scale",
  "hopes_dreams",
  "change_thing",
  "plan_complementary",
  "plan_complementary_notes",
  "supportive_people",
  "plan_goals",
  "plan_review_frequency",
  "plan_review_other",
  "participant_id",
  "prev_block_id",
  "session_date",
  "session_id",
  "date_changed",
  "date_created",
  "manage_external_id",
  "block_modified_fields",
  "recovery_plan_id",
  "organization_id",
  "session__location_ids",
  "session__program_identity_ids",
]
